import createApiClient from './createGenericApiClient';

const client = createApiClient('newsletter_base');

export const clearCache = client.clearCache;

export default client.performRequest;
